import { NgModule } from '@angular/core';
import { ElasticInputDirective } from './elastic-input.directive';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ ElasticInputDirective ],
    exports: [ ElasticInputDirective ],
})
export class ElasticInputDirectiveModule {}
